import { createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import reducer from "./reducers/index.js";

let store;
if (process.env.REACT_APP_STATE === "DEVELOPMENT") {
  store = createStore(reducer, composeWithDevTools());
} else if (process.env.REACT_APP_STATE === "PRODUCTION") {
  store = createStore(reducer);
}
console.log(store)
export default store;
